import React from 'react';

import { Actions, type ActionsProps } from '@atlassian/jira-issue-field-status';

const ActionsMenu = (props: ActionsProps) => <Actions {...props} />;

export default ActionsMenu;
